import { Ref, isRef, reactive, computed } from '@vue/composition-api';
import request from '@/utils/request';
import { Message } from 'element-ui';

type MaybeRef<T> = Ref<T> | T;

const dialogSubmit = computed(() => {
  switch (dialogObj.type) {
    case 'edit':
      return editRole;
    case 'add':
      return sendMail;
    case 'delete':
      return deleteRole;
    default:
      return editRole;
  }
});

const dialogObj = reactive({
  title: '新增人员',
  btnText: '发送邀请邮件',
  state: false,
  type: 'edit',
  SubmitEvent: dialogSubmit,
});

const tipsDialog = reactive({
  showDialog: false,
  icon: 'el-icon-warning',
  text: '已发送邀请邮件，待被邀请人注册！',
  btns: ['confirm', 'cancel'],
});

const showDialog = (stage: MaybeRef<boolean>): void => {
  isRef(stage) ? stage.value = true : stage = true;
};

const closeDialog = (stage: MaybeRef<boolean>, dialogData: Dialog.DialogFormData, defaultData: Dialog.DialogFormData): void => {
  Object.assign(dialogData, defaultData);
  isRef(stage) ? stage.value = !stage.value : stage = !stage;
};

const sendMail = async (params: Dialog.DialogFormData | unknown = {}): Promise<void> => {
  const res = await request('role', 'addRegister', params);
  if (res.code === 2000) {
    tipsDialog.showDialog = true;
    tipsDialog.text = '已发送邀请邮件，待被邀请人注册！';
    tipsDialog.icon = 'el-icon-warning';
    tipsDialog.btns = ['confirm'];
    dialogObj.state = false;
  } else {

  }
};

const editRole = async (params: Dialog.DialogFormData | unknown = {}): Promise<void> => {
  const res = await request('role', 'editSysUserRole', params);
  if (res.code === 2000) {
    tipsDialog.showDialog = true;
    tipsDialog.text = '编辑已保存！';
    tipsDialog.icon = 'el-icon-success';
    tipsDialog.btns = ['confirm'];
    dialogObj.state = false;
  } else {

  }
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const deleteRole = async (params: Dialog.DialogFormData | unknown = {}, listCallback): Promise<void> => {
  const res = await request('role', 'delSysUserRole', params);
  if (res.code === 2000) {
    Message.success('删除成功');
    if (listCallback && typeof listCallback === 'function') {
      listCallback();
    }
  } else {
    listCallback();
  }
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const dialogConfirm = (data: Dialog.DialogFormData, type: string, listCallback): void => {
  tipsDialog.showDialog = false;
  if (type === 'edit' && listCallback && typeof listCallback === 'function') {
    listCallback();
  }
  if (type === 'delete') {
    deleteRole(data, listCallback);
  }
  return;
};

export {
  showDialog,
  closeDialog,
  sendMail,
  editRole,
  deleteRole,
  tipsDialog,
  dialogObj,
  dialogSubmit,
  dialogConfirm
};
